export function convertToHumidityUnits(
  value: number | null,
): number | undefined {
  return value ?? undefined;
}

export function formatHumidityString(value: number): string {
  return `${value}%`;
}
